import { atom } from 'recoil';

interface INupayData {
  paymentLink: string;
  expiry: string;
}

export const nupayData = atom<INupayData | null>({
  key: 'nupayData',
  default: null,
});
